import {createBrowserRouter, Navigate, Outlet, RouterProvider} from 'react-router-dom';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {clearSession, hasRole, isLoggedIn} from './api';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import BollePage from './pages/BollePage';
import BollaPage from './pages/BollaPage';
import AvvisiPage from './pages/AvvisiPage';
import AmministrazionePage from './pages/AmministrazionePage';
import OrdiniPage from './pages/OrdiniPage';
import OrdinePage from './pages/OrdinePage';
import ClientiPage from './pages/ClientiPage';
import ClientePage from './pages/ClientePage';
import FatturePage from './pages/FatturePage';

// Le rotte figlie si vedono solo se loggati (e con almeno uno dei ruoli richiesti, se indicati).
function RequireAuth({roles}) {
    if (!isLoggedIn()) return <Navigate to="/login" replace/>;
    if (roles && !hasRole(...roles)) return <Navigate to="/" replace/>;
    return <Outlet/>;
}

function Logout() {
    clearSession();
    return <Navigate to="/login" replace/>;
}

const router = createBrowserRouter([
    {path: '/login', element: <LoginPage/>},
    {path: '/logout', element: <Logout/>},
    {
        element: <RequireAuth/>,
        children: [
            {path: '/', element: <HomePage/>},
            {path: '/bolle-viaggianti', element: <BollePage/>},
            {path: '/bolla', element: <BollaPage/>},
            {
                element: <RequireAuth roles={['ROLE_ADMIN']}/>,
                children: [
                    {path: '/avvisi', element: <AvvisiPage/>},
                    {path: '/amministrazione', element: <AmministrazionePage/>},
                    {path: '/ordini', element: <OrdiniPage/>},
                    {path: '/ordini/:id', element: <OrdinePage/>},
                    {path: '/clienti', element: <ClientiPage/>},
                    {path: '/clienti/:id', element: <ClientePage/>},
                    {path: '/fatture', element: <FatturePage/>},
                ],
            },
        ],
    },
    {path: '*', element: <Navigate to="/" replace/>},
]);

export default function App() {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <RouterProvider router={router}/>
        </GoogleOAuthProvider>
    );
}
